module.exports = __webpack_public_path__ + "img/resident-sheperd.7283c402.webp";